import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../consts/api";

export const useDeleteTimeTrackingGroup = (options = {}) => {
  const res = useMutation(
    (dto) =>
      http.delete(
        HTTP_ENDPOINTS.timeclockSettings.deleteTimeTrackingGroup(dto.id),
        dto,
      ),
    {
      ...options,
    },
  );
  return res;
};
